import React, { useEffect, useState } from "react";
import {
  Stack,
  Text,
  PrimaryButton,
  Icon,
  Spinner,
  SpinnerSize,
} from "@fluentui/react";
import { useNavigate } from "react-router-dom"; // O useHistory se usi router v5
import Tr from "../../Utils/Translations/Translations";
import ApiService from "../../Services/ApiService";
import { mobileCheck } from "../../App";
import { AppRoutes } from "../../AppRoutes";
import { useDispatch } from "react-redux";
import { IAPIResponse } from "../../Services/AjaxService";
import { GenericActions } from "../../Redux/Generic/GenericAction";

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [verifying, setVerifying] = useState(true);

  const GetPurchases = () => {
    ApiService.StoreController.GetPurchases(
      undefined,
      (response: IAPIResponse) => {
        if (response.error === null) {
          dispatch(GenericActions.setPurchases(response.parsed));
        }
        setVerifying(false);
      }
    );
  };

  useEffect(() => {
    // Appena atterriamo qui, chiediamo al backend di sincronizzarsi con Stripe
    // per essere sicuri che l'acquisto risulti "Pagato" prima che l'utente torni alla dashboard.
    ApiService.StoreController.UpdatePurchaseStatus((res) => {
      // Non ci importa troppo dell'esito qui, il webhook farà comunque il lavoro sporco.
      // Diamo solo un attimo di tempo al sistema.
      setTimeout(() => {
        setVerifying(false);
      }, 1000);
    });
  }, []);

  return (
    <Stack
      verticalAlign="center"
      horizontalAlign="center"
      styles={{
        root: {
          height: "100vh",
          width: "100%",
          padding: "2em",
          textAlign: "center",
        },
      }}
      tokens={{ childrenGap: 20 }}
    >
      {verifying ? (
        <Stack tokens={{ childrenGap: 10 }}>
          <Spinner
            size={SpinnerSize.large}
            label={Tr.Translate("language", "finalizing_payment")}
          />
        </Stack>
      ) : (
        <>
          <Icon
            iconName="CompletedSolid"
            styles={{
              root: {
                fontSize: mobileCheck() ? 80 : 120,
                color: "#107C10", // Verde Microsoft
              },
            }}
          />

          <Text variant="xxLarge" styles={{ root: { fontWeight: 600 } }}>
            {Tr.Translate("language", "payment_success_title")}
          </Text>

          <Text variant="large">
            {Tr.Translate("language", "payment_success_desc")}
          </Text>

          <div style={{ marginTop: "2em" }}>
            <PrimaryButton
              text={Tr.Translate("language", "go_to_workgroup_picker_page")}
              onClick={() => {
                GetPurchases();
                navigate(AppRoutes.WORKGROUP_PICK_PAGE);
              }}
              styles={{ root: { padding: "1.5em", minWidth: "200px" } }}
            />
          </div>
        </>
      )}
    </Stack>
  );
};

export default PaymentSuccessPage;
